import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { db } from '../../services/db';
import Button from '../common/Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Events = () => {
  const { t, language } = useLanguage();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    db.getEvent().then(setEvent);
  }, []);

  if (!event) return null;

  const title = language === 'es' ? event.titleEs : event.titleEn;
  const description = language === 'es' ? event.descriptionEs : event.descriptionEn;
  const registerUrl = event.registrationUrl || 'https://ProsperityMentors.net';

  return (
    <section id="events" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-pink-500">{t('events.title')}</h2>
        
        <div className="max-w-4xl mx-auto bg-gray-900 rounded-3xl p-8 md:p-12 border border-gray-800 hover:border-pink-600 transition-all duration-300 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-32 h-32 bg-pink-600 blur-[80px] opacity-20 group-hover:opacity-40 transition-opacity" />
          
          <div className="flex flex-col md:flex-row items-center gap-8 text-left">
            <div className="bg-gray-800 p-6 rounded-2xl text-center min-w-[120px]">
              <span className="block text-4xl font-bold text-white">{new Date(event.date).getDate()}</span>
              <span className="block text-pink-500 font-bold uppercase">{new Date(event.date).toLocaleString('default', { month: 'short' })}</span>
            </div>
            
            <div className="flex-1">
              <h3 className="text-2xl md:text-3xl font-bold mb-2">{title}</h3>
              <div className="flex items-center gap-2 text-gray-400 mb-4">
                <SafeIcon icon={FiIcons.FiMapPin} />
                <span>{event.location}</span>
              </div>
              <p className="text-gray-300 mb-6">{description}</p>
              <Button onClick={() => window.open(registerUrl, '_blank')} className="w-full md:w-auto">
                {t('events.register')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;